import * as actions from './actions'
import { IframeActions } from './actions'
import { IframeLoadingState } from '@mulesoft/monitoring-center-components'
import { IframeState } from './model'

const initialState: IframeState =  <IframeState> {
    state: IframeLoadingState.LOADING,
    src: ''
};

const reducer = (state: IframeState = initialState, action: IframeActions): IframeState => {
  switch (action.type) {
      case actions.ChangeIframeState:
          return {
              ...state,
              state: action.payload.state,
              src: action.payload.src
          };
    default:
      return state
  }
};

export default reducer
